var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80043 9.90902L5.61861 6.27266V5.36357H2.89134V6.27266H4.70952L2.89134 9.90902M7.43679 9.90902L9.25497 6.27266V5.36357H6.5277V6.27266H8.34588L6.5277 9.90902M11.0732 9.90902L12.8913 6.27266V5.36357H10.1641V6.27266H11.9822L10.1641 9.90902M18.3459 0.818115C17.3459 0.818115 16.5277 1.6363 16.5277 2.6363C16.5277 3.27266 16.8913 3.90902 17.4368 4.18175V14.4545H14.7095V12.6363C15.255 12.6363 15.6186 12.2727 15.6186 11.7272V3.54539C15.6186 2.99993 15.255 2.6363 14.7095 2.6363H11.255C10.5277 1.54539 9.25497 0.818115 7.89134 0.818115C6.5277 0.818115 5.25497 1.54539 4.5277 2.6363H1.07315C0.527699 2.6363 0.164062 2.99993 0.164062 3.54539V11.7272C0.164062 12.2727 0.527699 12.6363 1.07315 12.6363V18.9999H14.7095V16.2727H17.4368C18.4368 16.2727 19.255 15.4545 19.255 14.4545V4.18175C19.8004 3.90902 20.1641 3.27266 20.1641 2.6363C20.1641 1.6363 19.3459 0.818115 18.3459 0.818115ZM11.0732 16.2727H4.70952V14.4545H11.0732V16.2727ZM13.8004 10.8181H1.98224V4.45448H13.8004V10.8181Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.35e5aadf0c594dc00db498ee48f62539.svg";
export { ForwardRef as ReactComponent };